import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-automation-builder-form-setup',
  styleUrls: ['./form-setup.component.scss'],
  template: `<div class="container">
    <div class="container__top"><mat-icon>edit</mat-icon> {{ title }}</div>
    <div class="container__middle">
      <ng-content select="[middle]"></ng-content>
    </div>
    <div class="container__bottom"><ng-content select="[bottom]"></ng-content></div>
  </div> `,
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomationBuilderFormSetupComponent {
  @Input() title: string;
}
